import { Link, Route, Routes } from 'react-router-dom'
import './App.css'
import Christmas2023 from './pages/christmas2023'
import YearMiddleReport2025 from './pages/YearMiddleReport2025/index'
import YearMiddleReport2024 from './pages/YearMiddleReport2024/index'
import GroupBuying2024 from './pages/YearMiddleReport2024/GroupBuying'

import YearEndReport2023H1 from './pages/YearEndReport/index2023H1'
import YearEndReport from './pages/YearEndReport/index'
import YearEndReportDetail from './pages/YearEndReport/detail'
import MineReport from './pages/YearEndReport/mineReport'
import Invitation from './pages/YearEndReport/invitation'
import Bought from './pages/YearEndReport/bought'
import About from './pages/YearEndReport/about'
import Pay from './pages/YearEndReport/pay'
import Share from './pages/YearEndReport/share'
import GroupRecords from './pages/YearMiddleReport2024/GroupRecords'
import YearMiddleReport2024Detail from './pages/YearMiddleReport2024/Detail'
import Cheats from './pages/YearMiddleReport2024/Cheats'
// import wxConfig from './utils/wxConfig'

function App() {
  // console.log(111)
  // console.log('App---准备wxconfig啦')
  // wxConfig()
  return (
    <div className="App">
      <Routes>
        <Route path="/rlb/christmas2023" element={<Christmas2023 />} />
        {/* 2025年 */}
        <Route path="/rlb/YearMiddleReport2025" element={<YearMiddleReport2025 />} />

        {/* 2024年中 */}
        <Route path="/rlb/YearMiddleReport2024/:type" element={<YearMiddleReport2024 />} />
        <Route path="/rlb/YearMiddleReport2024/groupBuying" element={<GroupBuying2024 />} />
        <Route path="/rlb/YearMiddleReport2024/GroupRecords" element={<GroupRecords />} />
        <Route
          path="/rlb/YearMiddleReport2024/Detail/:id"
          element={<YearMiddleReport2024Detail />}
        />
        <Route path="/rlb/YearMiddleReport2024/Cheats/:id" element={<Cheats />} />

        {/* 2023年 */}
        {/* <Route path="/rlb/YearEndReport" element={<YearEndReport2023H1 />} /> */}
        <Route path="/rlb/YearEndReport/0" element={<YearEndReport2023H1 />} />
        <Route path="/rlb/YearEndReport/2023H2" element={<YearEndReport />} />
        <Route path="/rlb/YearEndReport/invitation" element={<Invitation />} />
        <Route path="/rlb/YearEndReport/bought" element={<Bought />} />
        <Route path="/rlb/YearEndReport/about" element={<About />} />
        <Route path="/rlb/YearEndReport/pay" element={<Pay />} />
        <Route path="/rlb/YearEndReport/share" element={<Share />} />

        {/* 公共 */}
        <Route path="/rlb/YearEndReport/mineReport" element={<MineReport />} />
        <Route path="/rlb/YearEndReport/detail/:id" element={<YearEndReportDetail />} />
      </Routes>
    </div>
  )
}

export default App
